import { render, staticRenderFns } from "./ScopedOverflowLayout.vue?vue&type=template&id=6ffe35fb&"
import script from "./ScopedOverflowLayout.vue?vue&type=script&lang=js&"
export * from "./ScopedOverflowLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports